<template>
  <div>
  <label for="">
    <span><slot></slot></span>
  </label>
  <TreeSelect
    v-model="selectedItems"
    :options="data"
  />
</div>
</template>

<script>
import TreeSelect from '@/components/TreeSelect.vue';

export default {
  name: "FilterTreeSelect",
  components: {
    TreeSelect
  },
  props: ["value", "options", "optionsAsync"],
  data() {
    return {
      data: [],
      selectedItems: []
    };
  },
  watch: {
    selectedItems(newVal) {
      if (newVal && newVal.length) {
        this.$emit("input", newVal);
      } else {
        this.$emit("input", null);
      }
    }
  },
  created() {
    if (this.optionsAsync) {
      this.optionsAsync().then((r) => {
        this.data = r;
      });
    } else {
      this.data = this.options ? this.options.slice(0) : [];
    }
    
    if (this.value && this.value.length) {
      this.selectedItems = this.value.slice();
    }
  }
};
</script>

